<template>
  <div>
    <div class="text-center">
      <img src="@/assets/logo-azul.png" class="logo-img" alt="Logo" />
    </div>
    <p class="login-description text-muted mt-2 mb-5">
      Entre com seu email e senha para acessar a área administrativa da
      plataforma Êxitos.
    </p>
    <form @submit.prevent="submit()">
      <b-form-group label="E-mail:">
        <b-form-input
          v-model="form.email"
          placeholder="E-mail"
          :state="validateState('email')"
        ></b-form-input>
        <b-form-invalid-feedback>
          <span v-if="!$v.form.email.required"
            >E-mail é um campo obrigatório.</span
          >
          <span v-if="!$v.form.email.email">E-mail inválido</span>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Senha:">
        <b-input-group class="login-pass">
          <b-form-input
            v-model="form.password"
            :state="validateState('password')"
            placeholder="Senha"
            type="password"
            class="input-pass"
          ></b-form-input>

          <b-input-group-append>
            <b-button
              class="button-show-pass"
              :class="{ 'text-muted': !show_pass }"
              :state="validateState('password')"
              @click="show_pass = !show_pass"
            >
              <font-awesome-icon icon="eye" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback :state="validateState('password')">
          <span v-if="!$v.form.password.minLength">Senha é obrigatório.</span>
        </b-form-invalid-feedback>
        <b-form-text>
          <span v-if="show_pass">{{ form.password }}</span>
          &nbsp;</b-form-text
        >
      </b-form-group>

      <b-row>
        <b-col class="d-flex justify-content-between">
          <router-link :to="{ name: 'esqueceu-senha' }"
            >Esqueceu a senha?
          </router-link>

          <b-button type="submit" variant="exitos">
            Entrar
            <font-awesome-icon icon="key" />
          </b-button>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  data: () => ({
    form: {
      email: "",
      password: "",
    },
    show_pass: false,
    error_message: "",
  }),
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  computed: {
    to_route() {
      let response = { name: "Home" };
      try {
        let { resolved } = this.$router.resolve(this.$route.query.to);
        if (resolved.name) {
          response = resolved.fullPath;
        }
      } catch (err) {}

      return response;
    },
  },
  methods: {
    ...mapActions("auth", ["ActionDoLogin"]),
    async submit() {
      this.error_message = "";

      try {
        this.$v.$touch();
        if (!this.$v.$anyError) {
          await this.ActionDoLogin(this.form);
          this.$router.push(this.to_route);
        }
      } catch (err) {
        console.log("ERR", err);
        this.$notifications.addNotification({
          message: "Usuário ou senha inválidos.",
          type: "danger",
        });
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  },
  created() {},
};
</script>

<style lang="scss">
</style>
